import React from "react";
import PlacementItem from "./PlacementItem";
import {CmLinkable} from "../../../../packages/graphql-layer/src";
import PreviewPlacementHighlighter from "../../preview/PreviewPlacementHighlighter";

interface Props {
    placementName: string,
    items: Array<CmLinkable>,
    viewtype: string,
    CAEGlobalSettings: any,
    csrfToken: string,
    isPreview?: boolean,
    placeholderContent?: any,
    pageSettings?: any,
    credentials?: any
}

function PageGridPlacement(props: Props) {
    return <PreviewPlacementHighlighter placementName={props.placementName} hasItems={!!props.items}>
        {props.items.map((i, index) =>
            <PlacementItem key={index}
                           item={i}
                           CAEGlobalSettings={props.CAEGlobalSettings}
                           csrfToken={props.csrfToken}
                           isPreview={props.isPreview}
                           placeholderContent={props.placeholderContent}
                           pageSettings={props.pageSettings}
                           credentials={props.credentials}/>)}
    </PreviewPlacementHighlighter>
}

export default PageGridPlacement